import LeftContent from "../../../../src/pages/pricing/contact/left-content.md";
import RightContent from "../../../../src/pages/pricing/contact/right-content.md";
import * as React from 'react';
export default {
  LeftContent,
  RightContent,
  React
};